import './login.css';
import LoginTradicional from '../../loginTabs/LoginTradicional';
import LoginViaGoogle from '../../loginTabs/LoginGoogle';
import { ToastContainer } from 'react-toastify';

export default function LoginIndexPage() {
  return (
    <>
      <ToastContainer position="top-center" />
      <section className="ftco-section">
        <div className="logincontainer">
          <div className="loginrow justify-content-center">
            <div className="col-md-12 col-lg-10">
              <div className="wrap d-md-flex">
                <div className="logintext-wrap p-4 p-lg-5 text-center d-flex align-items-center order-md-last">
                  <div className="text w-100">
                    <h2 className="opacity-0">
                      Sistema de Gestão da Corregedoria dos Defensores
                    </h2>
                  </div>
                </div>

                <div className="login-wrap p-4 p-lg-5">
                  <div className="d-flex">
                    <div className="w-100">
                      <h4 className="mb-4">Sistema de Gestão Interna</h4>

                      <ul className="nav nav-tabs mb-4" id="loginTab">
                        <li className="nav-item">
                          <a
                            data-bs-toggle="tab"
                            data-bs-target="#login-1"
                            type="button"
                            role="tab"
                            aria-controls="login-1"
                            aria-selected="true"
                            className="nav-link active"
                          >
                            Tradicional
                          </a>
                        </li>
                        {/* <li className="nav-item">
													<a data-bs-toggle="tab" data-bs-target="#login-2" type="button" role="tab" aria-controls="login-2" aria-selected="false" className="nav-link">
														Token
													</a>
												</li> */}
                        <li className="nav-item">
                          <a
                            data-bs-toggle="tab"
                            data-bs-target="#login-3"
                            type="button"
                            role="tab"
                            aria-controls="login-3"
                            aria-selected="false"
                            className="nav-link"
                          >
                            Google
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="tab-content" id="loginTabContent">
                    <div
                      id="login-1"
                      role="tabpanel"
                      aria-labelledby="login-1"
                      className="tab-pane active show"
                    >
                      <LoginTradicional />
                    </div>
                    {/* <div id="login-2" role="tabpanel" aria-labelledby="login-2" className="tab-pane">
											<LoginToken />
										</div> */}
                    <div
                      id="login-3"
                      role="tabpanel"
                      aria-labelledby="login-3"
                      className="tab-pane"
                    >
                      <LoginViaGoogle />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
